export default "__VITE_ASSET__BraPs8uL__"